import { InstantiatedTemplateRow } from './InstantiatedTemplateRow';

export function TemplateInstantiationDetails({
  toolInput,
  toolResult,
}: {
  toolInput?: Record<string, unknown>;
  toolResult?: Record<string, unknown>;
}) {
  const selection = toolInput && typeof toolInput === 'object'
    ? (toolInput.selection as Record<string, unknown> | undefined)
    : undefined;
  const reason = toolInput && typeof toolInput.reason === 'string' ? toolInput.reason as string : undefined;
  const generatedFiles = toolResult && Array.isArray(toolResult.generatedFiles)
    ? toolResult.generatedFiles as string[]
    : undefined;
  const activeTemplaters = toolResult && Array.isArray(toolResult.activeTemplaters)
    ? toolResult.activeTemplaters as string[]
    : undefined;

  const entries = selection
    ? Object.entries(selection).filter(([, v]) => v && typeof v === 'object')
    : [];

  return (
    <div className="pipeline-template-instantiation" data-testid="pipeline-template-instantiation">
      {reason && <div className="pipeline-plan-reasoning">{reason}</div>}
      {entries.length > 0 && (
        <div className="pipeline-selected-templates">
          {entries.map(([category, value]) => {
            const v = value as { templateId?: string; config?: Record<string, unknown> };
            return (
              <InstantiatedTemplateRow
                key={category}
                category={category}
                templateId={v.templateId}
                config={v.config}
              />
            );
          })}
        </div>
      )}
      {activeTemplaters && activeTemplaters.length > 0 && (
        <div className="pipeline-template-depends">
          <span className="pipeline-template-options-label">Active templaters:</span>
          <span className="pipeline-template-options-value">{activeTemplaters.join(', ')}</span>
        </div>
      )}
      {generatedFiles && generatedFiles.length > 0 && (
        <div className="pipeline-modified-files">
          {generatedFiles.map(f => (
            <span key={f} className="pipeline-file-chip">{f}</span>
          ))}
        </div>
      )}
    </div>
  );
}
